import React, {
  useCallback, useState, useEffect, memo,
} from 'react';
import * as Styles from './SshKeysPage.styles';
import {
  IconArrow, Button, AlertV2, Skeleton,
} from 'gatorcomponents';

import useLocale from '@/hooks/useLocale';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';

import ContentSection from '@/pages/Products/VpsOciDetailPage/commons/ContentSection';

import About from './components/About';
import SshKeysList from './components/SshKeysList';
import CreateKeyModal from './components/CreateKeyModal';

import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';
import { useParams } from 'react-router-dom';

const SshKeysPage = memo(({
  setShowSshKeysPage,
}) => {
  const dispatch = useDispatch();
  const { id: hostingId } = useParams();

  const [openModalCreateKey, setOpenModalCreateKey] = useState(false);

  const { sshKeysData, loading, error } = useSelector(state => ({
    sshKeysData: state.vpsOci?.sshKeys?.fetch?.data,
    loading: state.vpsOci?.sshKeys?.fetch?.loading,
    error: state.vpsOci?.sshKeys?.fetch?.error,
  }), shallowEqual);

  const isLoading = Boolean(loading);

  const { productDetails: productDetailsLocale } = useLocale();
  const { sshKeys: sshKeysLocale } = productDetailsLocale?.vpsOci;

  const limitMaxReached = sshKeysData?.keys?.length >= sshKeysData?.maxKeys;
  const disableCreateKeyButton = limitMaxReached || Boolean(error) || loading;

  const handleBackSshKeysPage = useCallback(() => {
    setShowSshKeysPage && setShowSshKeysPage(false);
  }, [setShowSshKeysPage]);

  const handleOpenModalCreateKey = () => {
    setOpenModalCreateKey(true);
  };

  const handleCloseModalCreateKey = () => {
    setOpenModalCreateKey(false);
  };

  useEffect(() => {
    if (hostingId && !sshKeysData) {
      dispatch(vpsOciActions.sshKeys.fetch.request(hostingId));
    }
  }, [dispatch, hostingId, sshKeysData]);

  return (
    <Styles.Container data-testid="ssh-keys-page">
      <Styles.WrapperButton>
        <Button
          label={sshKeysLocale.management.backButton}
          variant="tertiary"
          size="large"
          version="v2"
          width="fit"
          iconLeft={<IconArrow color="primaryMedium" size="md" />}
          onClick={handleBackSshKeysPage}
          testId="ssh-keys-back-button"
        />
      </Styles.WrapperButton>

      <About
        disableCreateKeyButton={disableCreateKeyButton}
        handleOpenModalCreateKey={handleOpenModalCreateKey}
      />

      {limitMaxReached && (
        <AlertV2
          description={sshKeysLocale.management.list.limitMaxReached}
          testId="ssh-keys-limit-max-reached-alert"
          variant="pending"
          width="full"
          withoutBackground={false}
        />
      )}


      {isLoading ? (
        <Styles.SkeletonWrapper data-testid="ssh-keys-skeleton-loader">
          <Skeleton variant="rectangle" width="100%" height="400px" />
        </Styles.SkeletonWrapper>
      ) : (
        <ContentSection
          direction="row"
          align="center"
          justify="space-between"
        >
          <SshKeysList
            sshKeysData={sshKeysData}
            error={error}
            loading={loading}
            onOpenModalCreateKey={handleOpenModalCreateKey}
          />
        </ContentSection>
      )}

      {openModalCreateKey && <CreateKeyModal onClose={handleCloseModalCreateKey} />}
    </Styles.Container>
  );
});

export default SshKeysPage;
